import * as React from 'react';

const TicketMultiFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="ticket-multi-fill_svg__eds-icon--ticket-multi-fill_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="#231f20"
            d="M20 3v19h-4v1h5V3h-1zM9.1 22a4.14 4.14 0 012.3-2.7 2.18 2.18 0 01.9.7 3.21 3.21 0 00-2.3 3H5v-1z"
        />
        <path
            d="M14 1s0 3.5-3 3.5S8 1 8 1H3v20h5a2.94 2.94 0 012.88-3H11a2.94 2.94 0 013 2.88V21h5V1zM8 11.5H6v-1h2zm4 0h-2v-1h2zm4 0h-2v-1h2z"
            fill="#231f20"
        />
    </svg>
);

TicketMultiFillSvg.displayName = 'TicketMultiFillSvg';
export default TicketMultiFillSvg;
